import { Col, Container, LoadingSpinner, Row } from '@paypalcorp/pp-react';
import React from 'react';
import PropTypes from 'prop-types';
import clx from 'classnames';
import styles from './Loading.module.less';

function Loading({ inverse, size }) {
  return (
    <Container fluid data-testid="loadingspinner-container">
      <Row className={styles.loading_row}>
        <Col className={styles.loading_col}>
          <LoadingSpinner
            inverse={inverse}
            className={clx({
              [styles.loading_spinner]: true,
              [styles.loading_inverse]: inverse
            })}
            size={size}
          />
        </Col>
      </Row>
    </Container>
  );
}

Loading.propTypes = {
  inverse: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};

Loading.defaultProps = {
  inverse: false,
  size: 'sm'
};

export default Loading;
